<template>
    <div class="data gdpr-container">
        <h4 class="data__title">Solicitare Date Personale</h4>
        <div class="data__content">
            <p class="data__text">
                In conformitate cu prevederile Regulamentului (UE) 2016/679 al Parlamentului European si al Consiliului din 27 aprilie 2016 privind protectia persoanelor fizice in ceea ce priveste prelucrarea datelor cu caracter personal si privind libera circulatie a acestor date si de abrogare a Directivei 95/46/CE (Regulamentul general privind protectia datelor) dvs. ca si persoana vizata aveti dreptul de a solicita Operatorului, in ceea ce priveste datele dvs. cu caracter personal:
            </p>
            <p class="data__text">
                *accesul la acestea
            </p>
            <p class="data__text">
                *rectificarea sau stergerea acestora
            </p>
            <p class="data__text">
                *restrictionarea prelucrarii.
            </p>
            <p class="data__text">
                Totodata, aveti dreptul de a va opune prelucrarii, precum si dreptul la portabilitatea datelor.
            </p>
        </div>
        <form class="data__form">
            <div class="form-row">
                <div class="col-12 col-md-6">
                    <input type="text" id="firstName" class="form-control data__input" v-model="user.nume.value" required placeholder="Nume">
                </div>
                <div class="col-12 col-md-6">
                    <input type="text" id="lastName" class="form-control data__input" v-model="user.prenume.value" required placeholder="Prenume">
                </div>
            </div>
            <div class="form-row">
                <div class="col-12">
                    <input type="email" id="email" class="form-control data__input" v-model="user.email.value" required placeholder="Email">
                </div>
            </div>
            <div class="form-row">
                <div class="col-12">
                    <select name="option" id="option" class="form-control data__input" v-model="user.motiv.value" required>
                        <option value="default" disabled="true" selected="true">Alege un motiv</option>
                        <option value="editare">Editare</option>
                        <option value="stergere">Stergere</option>
                        <option value="portare">Portare</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="col-12">
                    <textarea name="message" id="message" cols="30" rows="3" class="form-control data__input" v-model="user.observatii.value" placeholder="Observatii"></textarea>
                </div>
            </div>
            <div class="error text-danger mt-3 text-center" v-if="errors.length > 0">
                <p class="error__text mb-1">Va rugam sa corectati urmatoarele erori:</p>
                <p v-for="(error, index) in errors" :key="index" class="error__message mb-1">{{ error }}</p>
            </div>
            <div class="success text-success mt-1 text-center" v-if="successMessage !== ''">
                <p class="success__text mb-1"> {{ successMessage }} </p>
            </div>
            <div class="data__btn-container">
                <button class="btn btn-primary call-to__button" @click.prevent="sendForm">Trimite</button>
            </div>
        </form>
    </div>
</template>

<script>
    import GlobalService from './../../services/Global'
    export default {
        data () {
            return {
                user: {
                    nume: { 
                        value: '',
                        name: 'Nume'
                    },
                    prenume: {
                        value: '',
                        name: 'Prenume'
                    },
                    email: {
                        value: '',
                        name: 'Email',
                        type: 'email'
                    },
                    motiv: {
                        value: 'default',
                        name: 'Motiv'
                    },
                    observatii: {
                        value: '',
                        name: 'Observatii'
                    }
                },
                errors: [],
                dataSent: {},
                successMessage: ''
            }
        },
        created () {
            GlobalService.goToTop()
        },
        methods: {
            sendForm () {
                this.checkErrors()
                if(this.errors.length == 0) {
                    for(let i in this.user) {
                        this.dataSent[i] = this.user[i].value
                    }
                    this.$http.post(`/postgdpr`, {
                        ...this.dataSent
                    }).then(response => {
                        this.successMessage = response.data.success
                        this.resetForm()
                        setTimeout(() => {this.successMessage = ''}, 3000)
                    }).catch(e => console.log(e))
                }
            },
            checkErrors () {
                this.errors = []
                for(let i in this.user) {
                    if(this.user[i].value.trim() === '') {
                        this.errors.push(`Campul ${this.user[i].name} este obligatoriu.`)
                    } else if (this.user[i].value === 'default') {
                        this.errors.push(`Selectati un motiv.`)
                    }
                    if(this.user[i].type === 'email' && this.user[i].value.trim() !== '') {
                        if(!(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.user[i].value))) {
                            this.errors.push('Email invalid.') 
                        }
                    }
                }
            },
            resetForm () {
                for(let i in this.user) {
                    this.user[i].value = ''
                }
                let form = document.querySelector('.data__form')
                form.reset()
            }
        }
    }
</script>